<script lang="ts">
    import { onDestroy, onMount } from "svelte";
    import FavoriteTranslationMarkersManager from "./FavoriteTranslationMarkersManager.svelte";
    import {
        checkFavoriteTranslations,
        markTranslationAsFavorite,
        markTranslationFromCurrentDictionaryAsFavorite,
    } from "./FlashcardsIntegration.service";
    import MyFavoriteTranslations from "./favoriteTranslationsPage/MyFavoriteTranslations.svelte";
    import MyFavoriteTranslationsAccordion from "./favoriteTranslationsPage/MyFavoriteTranslationsAccordion.svelte";
    import {
        getLoginUrl,
        isLoggedIn,
    } from "@app/services/transferState-service";
    import { addFloatingMessage } from "../FloatingMessages/FloatingMessages.controller";
    import { getMessage } from "@app/services/i18n.service";
    import {
        COMMON__You_need_to_logIn_first,
        COMMON__logIn,
    } from "@app/services/i18n.messages";
    import { sendFavoriteAnalyticsEvent } from "@app/services/analytics/analytics-send-event";

    const ACTIVATOR_SELECTOR = "button.add-to-favorite";

    document.addEventListener("click", async (clickEvent: Event) => {
        const targetElement = clickEvent.target;

        if (targetElement instanceof HTMLButtonElement) {
            let element = targetElement as HTMLElement;
            let matched = element.matches(ACTIVATOR_SELECTOR);
            while (
                element != null &&
                element.parentElement != null &&
                !matched
            ) {
                element = element.parentElement;
                matched = element.matches(ACTIVATOR_SELECTOR);
            }

            if (matched && !element.dataset["isInFavorites"]) {
                sendFavoriteAnalyticsEvent({
                    action: "markFavoriteNotLoggedIn",
                });
                if (!isLoggedIn()) {
                    addFloatingMessage({
                        title: getMessage(COMMON__You_need_to_logIn_first),
                        body: "",
                        type: "warn",
                        actions: [
                            {
                                text: getMessage(COMMON__logIn),
                                linkUrl: getLoginUrl(),
                            },
                        ],
                    });
                    return;
                }
                const translationPhrase = element
                    .closest("li")
                    .querySelector(".translation__item__pharse")
                    ?.textContent.trim();
                await markTranslationFromCurrentDictionaryAsFavorite(
                    translationPhrase
                );
            }
        }
    });
    onMount(() => {
        document.addEventListener(
            "glosbe.newTranslationsLoaded",
            checkFavoriteTranslations
        );
    });

    onDestroy(() => {
        document.removeEventListener(
            "glosbe.newTranslationsLoaded",
            checkFavoriteTranslations
        );
    });

    checkFavoriteTranslations();

    const userFavoriteTranslationsElement = document.getElementById(
        "userFavoriteTranslations"
    );
    if (userFavoriteTranslationsElement) {
        new MyFavoriteTranslations({
            target: userFavoriteTranslationsElement,
        });
    }

    document
        .querySelectorAll("[data-sv=favoriteTranslations]")
        .forEach((targetElement) => {
            new MyFavoriteTranslationsAccordion({
                target: targetElement,
            });
        });
</script>

<FavoriteTranslationMarkersManager />
